<template>
  <div>
    <div class="mask">
      <Form ref="formInline" :model="formInline" :rules="ruleInline">
        <div class="forget-password">
          <div class="forget-password-play">
            <div class="modify">
              <div class="forgetPsd">
                <span class="forgetPsdText">{{$t('i.login.forgetThePassword')}}</span>
                <Icon type="md-close" size="28" class="md-close" @click="closePsd"/>
              </div>

              <div class="typeCompany">
                <div class="nameSpan">
                  <span>{{$t('i.personalInformation.typeOfCompany')}}</span>
                </div>
                <div style="float: left;">
                  <FormItem prop="company">
                    <Select style="width:200px" v-model="formInline.company">
                      <Option v-for="(typeCompany,index) in typeCompanys" :key="typeCompany.entry_code" :value="typeCompany.entry_code">{{ typeCompany.entry_name }}</Option>
                    </Select>
                  </FormItem>
                </div>
              </div>
              <div class="name">
                <div class="nameSpan">
                  <span>{{$t('i.login.username')}}</span>
                </div>
                <div style="float: left;">
                  <FormItem prop="username">
                    <Input v-model="formInline.username" placeholder="name" style="width: 200px" />
                  </FormItem>
                </div>
              </div>

              <div class="verificationCode">
                <div class="nameSpan">
                  <span>{{$t('i.login.verificationCode')}}</span>
                </div>
                <div style="float: left;">
                  <FormItem prop="captcha">
                    <Input v-model="formInline.captcha" placeholder="Verification Code" style="width: 100px;" />
                  </FormItem>
                </div>
                <div class="verification-code-img">
                  <img :src="verificationCodeURI" v-on:click="verificationCodeURI  = Constants.serverURL+'/validateCode?_='+new Date().getTime();" alt="验证码">
                </div>
              </div>

            <div class="name">
                <div class="nameSpan">
                  <span>{{$t('i.login.pwdForgetType')}}</span>
                </div>
                <div style="float: left;">
                   <Select style="width:200px" v-model="is_show">
                      <Option  value="1">{{$t('i.login.mobileVerificationCode')}}</Option>
                      <Option  value="2">{{$t('i.login.pwdQuestion')}}</Option>
                    </Select>
                </div>
            </div>

            <div v-show="is_show == 1">
              <div class="phoneverificationCode">
                  <span class="nameSpan">{{$t('i.login.mobileVerificationCode')}}</span>
                <div style="float: left;">
                  <FormItem>
                    <Input v-model="formInline.mobileCaptcha" placeholder="Mobile verification code" style="width: 100px;" />
                  </FormItem>
                </div>
                <input type="button" class="primary" @click="getPassword()" ref="verification" :value="$t('i.login.getPhoneVerificationCode')">
              </div>
            </div>  

         
          <div v-show="is_show == 2">
            <template v-for="(item,index)  in pwdQuestion">
              <div class="newPsd">
                <div class="nameSpan">
                  <span>{{$t('i.login.pwdQuestion')}}{{index+1}}</span>
                </div>
                <div style="float: left;">
                  <p style="line-height: 30px;">{{item.title}}</p>
                </div>
              </div>
              <div class="newPsd">
                <div class="nameSpan">
                  <span >{{$t('i.login.pwdAnswer')}}</span>
                </div>
                <div style="float: left;">
                  <FormItem>
                    <Input  v-model="pwdQuestion[index].answer" placeholder="Password answer" style="width: 200px" />
                  </FormItem>
                </div>
              </div>
            </template>
          </div>


              <div class="newPsd">
                <div class="nameSpan">
                  <span >{{$t('i.login.newPassword')}}</span>
                </div>
                <div style="float: left;">
                  <FormItem prop="password">
                    <Input type="password" v-model="formInline.password" placeholder="New password" style="width: 200px" />
                  </FormItem>
                </div>
              </div>

              <div class="confirmPsd">
                <div class="nameSpan">
                  <span>{{$t('i.login.newPasswordC')}}</span>
                </div>
                <div style="float: left;">
                  <FormItem prop="passwordC">
                    <Input type="password" v-model="formInline.passwordC" placeholder="Confirm password again" style="width: 200px" />
                  </FormItem>
                </div>
              </div>
              <div class="resetPassword">
                <Button type="primary"  @click="findPasswd('formInline')">{{$t('i.login.resetPassword')}}</Button>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
  import CryptoJS from 'crypto-js/crypto-js';
  export default {
    name: "forgetPassword",
    data(){
      const passwdCheck = (passwd,level) => {
        if(passwd == null || passwd == ""){
          return false;
        }
        var lev = "medium";
        var strongRegex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
        var mediumRegex = new RegExp("^(?=.{8,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g");
        var enoughRegex = new RegExp("(?=.{8,}).*", "g");
        if(level){
          lev = level;
        }
        if(lev == "high"){
          return strongRegex.test(passwd);
        }else if(lev == "medium"){
          return mediumRegex.test(passwd);
        }else if(lev == "low"){
          return enoughRegex.test(passwd);
        }else{
          return mediumRegex.test(passwd);
        }
      };
      const validatePassword = (rule, value, callback) =>{
        if(!passwdCheck(value)){
          callback(new Error('密码复杂程度不够，请输入字母加数字，区分大小写！'));
        }else{
          callback();
        }
      };
      const validatePasswdC = (rule, value, callback) => {
        const password = this.formInline.password;
        console.log("password",password);
        if(value == password){
          callback();
        }else{
          callback(new Error('两次密码不同，请重新输入！'));
        }
      };
      return {
        is_show : "0",
        smsId: '',
        typeCompanys:[],
        pwdQuestion:[],
        recapture: this.$t('i.login.recapture'),
        gePhoneNumber: this.$t('i.login.gePhoneNumber'),
        verificationCodeURI: '',
        formInline: {
          username: '',
          company: '',
          captcha: '',
          mobileCaptcha: '',
          password: '',
          passwordC: '',
        },
        ruleInline: {
          company: [
            { required: true, message: this.$t('i.login.company'), trigger: 'change'}
          ],
          username: [
            { required: true, message: this.$t('i.login.user_message'), trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: this.$t('i.login.verificationCode_message'), trigger: 'blur' }
          ],
          mobileCaptcha: [
            { required: true, message: this.$t('i.login.mobileCaptcha'), trigger: 'blur' },
          ],
          password: [
            { required: true, message: this.$t('i.login.newPassword'), trigger: 'blur' },
            { type: 'string', min: 8,message: this.$t('i.login.password_length_message'),  trigger: 'blur' },
            { validator: validatePassword, trigger: 'blur' },
          ],
          passwordC: [
            { required: true, message: this.$t('i.login.newPasswordC'), trigger: 'blur' },
            { type: 'string', min: 8,message: this.$t('i.login.password_length_message'),  trigger: 'blur' },
            { validator: validatePassword, trigger: 'blur' },
            { validator: validatePasswdC, trigger: 'blur' },
          ],
        },
      }
    },
    methods:{
      async companyList(){
        const json = await this.RequestUtil.request("/companyList");
        if(json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.typeCompanys = json.datas;
          }
        }
      },
      async getPwdQuestion(){
        const json = await this.RequestUtil.request("/getPwdQuestion");
        if(json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.pwdQuestion = json.datas;
          }
        }
      },
      async getPassword()  {
        let recapture = this.$t('i.login.recapture');
        let gePhoneNumber = this.$t('i.login.gePhoneNumber');
        console.log(recapture);
        let url = "/sendSMSCaptcha?company=" + this.formInline.company;
        url += "&username=" + this.formInline.username +"&captcha="+ this.formInline.captcha;
        const json = await this.RequestUtil.request(url);
        if(json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.smsId = json.datas.captcha;
            this.$Message.success(json.message);
          }
        }
        let then = this.$refs.verification;
        let time = 60
        let countDown = setInterval(function () {
          time--
          then.value  = time + recapture;
          then.style.color = '#ccc'
          then.disabled = ' disabled'
          if (time === 0) {
            then.disabled = ''
            then.style.color = ' #fff'
            then.value = gePhoneNumber
            clearInterval(countDown)
          }
        }, 1000)
      },
      closePsd(){
        this.$emit('closeChangePasswd');
        this.$emit('closeForgetPasswd','0');
      },
      findPasswd(name){
        this.$refs[name].validate(async (valid) => {
          if (valid) {

            if(this.is_show == 0){
              //请选择类型
              this.$Message.error({
                content: this.$t('i.login.pwdForgetTypeMsg'),
                duration: 3,
                closable: true
              });
              return false
            }else if(this.is_show == 1){
              //手机验证码
              if(this.formInline.mobileCaptcha == '' || this.formInline.mobileCaptcha == null){
                     this.$Message.error({
                      content: this.$t('i.login.mobileCaptcha'),
                      duration: 3,
                      closable: true
                    });
                    return false
              }
            }else{
              //密保问题
              for(var i = 0 ;i<this.pwdQuestion.length;i++){
                if(this.pwdQuestion[i].answer == '' || this.pwdQuestion[i].answer == null){
                  this.$Message.error({
                      content: this.$t('i.login.pwdForgetWarn'),
                      duration: 3,
                      closable: true
                    });
                    return false
                  break;
                }
              }
            }

            let url = "/resetPasswd?smsId=" + this.smsId;
            url += "&company=" + this.formInline.company;
            url += "&username=" + this.formInline.username;
            url += "&captcha=" + this.formInline.captcha;
            url += "&mobileCaptcha=" + this.formInline.mobileCaptcha;
            url += "&password=" + CryptoJS.SHA256(this.formInline.password);
            url += "&passwordC=" + CryptoJS.SHA256(this.formInline.passwordC);
            url += "&type=" + this.is_show;
            const json = await this.RequestUtil.request(url,this.pwdQuestion);
            if(json) {
              if (json.statusCode == this.Constants.statusCode.ok) {
                this.$Message.success(json.message);
                // this.$emit('closeForgetPasswd','0');
                setTimeout(() => {
                  // window.location.href = this.Constants.serverURL;
                  // this.$router.push({name:'login'})
                  this.$router.go(0);
                },1000);
              }
            }
          }
        });
      },
      refreshCaptcha(){
        this.verificationCodeURI  = this.Constants.serverURL+'/validateCode?_='+Date.now()+'&t_=forget-password';
      },
      is_type_change(){
        if(this.is_type == 1){
            this.is_type = 1
        }else{
            this.is_type = 2
        }
      }
    },
    mounted(){
      this.companyList();
      this.getPwdQuestion();
    }
  }
</script>

<style scoped>
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,.10);
    top: 0;
    left: 0;
  }
  .forget-password{
    width: 100%;
    height: 600px;
  }
  .forget-password-play{
    width: 600px;
    height: 500px;
    margin: 100px auto;
    border-radius: 20px;
    border: 2px solid #ccc;
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .modify {
    width: 600px;
    height: 50px;
    float: left;
  }
  .forgetPsd{
    width: 600px;
    height: 50px;
    margin-top: 10px;
    text-align: center;
  }
  .md-close{
    float: right;
    margin-right: 30px;
    cursor: pointer;
  }
  .forgetPsdText{
    font-size: 25px;
  }
  .primary{
    width: auto;
    height: 32px;
    border-radius: 5px;
    background-color: #2d8cf0;
    border: 0;
    color:#fff;
    cursor: pointer;
    margin-left: 8px;
  }
  .name,
  .typeCompany,
  .verificationCode,
  .phoneverificationCode,
  .newPsd,
  .confirmPsd
  {
    width: 600px;
    height: 40px;
    margin-bottom: 18px;
    margin-top: 10px;
  }
  .resetPassword{
    width: 500px;
    height: 50px;
    text-align: center;
    margin: 15px auto;
  }
  .resetPassword p{
    margin-top: 5px;
  }
  .nameSpan{
    width: 220px;
    height: 30px;
    text-align: right;
    float: left;
    line-height: 30px;
    margin-right: 5px;
  }

  .verification-code-img{
    margin-left: 8px;
    margin-top: 2px;
    float: left;
  }
  .verification-code-img img{
     width: 90px;
     height: 30px;
     border-radius: 5px;
     cursor: pointer;
   }
</style>



// WEBPACK FOOTER //
// src/pages/forgetPassword/forgetPassword.vue